import {
  Fade,
  Grid,
  Box,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import UploadIcon from '@mui/icons-material/Upload';
import KenDialog from '../../../../Components/KenDialog';
import { useDropzone } from 'react-dropzone';
import { TABLET_BREAKPOINT } from '../../../../Constants/constant';
import Menu from '@mui/material/Menu';
import { saveAs } from 'file-saver';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Eye from '../../../../Assets/Svg/eye.svg';
import Download from '../../../../Assets/Svg/download.svg';
import Replace from '../../../../Assets/Svg/replace.svg';
import { useSnackbar } from 'notistack';
import { getDocumentByDocId } from '../../../../Utils/apiServices';
import { FileViewer } from 'react-file-viewer';
import moment from 'moment';
import KenLoader from '../../../../Components/KenLoader';

const useStyles = makeStyles((theme) => ({
  container: {
    background: '#F7F8FB',
    padding: '8px 16px',
    borderRadius: 4,
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      padding: '4px',
    },
  },
  documentLabel: {
    float: 'left',
    textAlign: 'left',
    color: theme.palette.KenColors.grey2,
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: '50%',
      'word-break': 'break-word',
    },
  },
  icon: {
    color: theme.palette.KenColors.grey3,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  iconRejected: {
    color: theme.palette.KenColors.green,
    opacity: 0.8,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  status: {
    color: theme.palette.KenColors.kenWhite,
    padding: '4px 14px',
    borderRadius: 4,
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      padding: '4px',
      fontSize: '10px',
    },
  },
  uploadLabel: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      'font-style': 'normal',
      'font-weight': '500',
      'font-size': '14px',
      'line-height': '100%',
      color: theme.palette.KenColors.gradeSectionHeaderLabel,
      minWidth: '164px',
      display: 'inline-block',
    },
  },
  menuItem: {
    display: 'flex',
    'font-style': 'normal',
    'font-weight': '400',
    'font-size': '14px',
    'line-height': '100%',
    color: '#505F79',
    '& > img': {
      marginRight: '8px',
    },
  },
  moreOptions: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      padding: '0px !important',
    },
  },
}));

const getStatus = ({
  isMobileScreen,
  status,
  classes,
  getRootProps,
  getInputProps,
  open,
}) => {
  return !status && isMobileScreen ? (
    <Grid item {...getRootProps({ className: 'dropzone' })}>
      <input {...getInputProps()} />
      <span onClick={open} className={classes.uploadLabel}>
        Upload Document
      </span>
    </Grid>
  ) : (
    <Grid item md={3} xs={12}>
      <Typography
        variant="body4"
        className={classes.status}
        sx={
          status === 'Accepted'
            ? { background: '#4BB99A' }
            : status === 'Pending Review'
            ? { background: '#2862FF', opacity: '0.6' }
            : status === 'Rejected'
            ? { background: '#FE7E6D' }
            : { background: 'none' }
        }
      >
        {status ? status : '---'}
      </Typography>
    </Grid>
  );
};
const ITEM_HEIGHT = 48;

export default function DocumentList(props) {
  const { onChange, value = [], title, fileName, status, expiryDate } = props;
  const [filePreview, setFilePreview] = useState(false);
  const classes = useStyles();
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [loader, setLoader] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [fileType, setFileType] = useState(null);

  const menuOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    multiple: false,
    noKeyboard: true,
    accept:
      title === 'Cheque' ||
      title.toLowerCase().includes('photo') ||
      title.toLowerCase().includes('passport')
        ? ['image/jpeg', 'image/png']
        : ['application/pdf'],
    onDrop: (acceptedFiles, fileRejections) => {
      if (fileRejections.length < 0) {
        enqueueSnackbar(
          fileRejections[0]?.errors[0]?.message.replace('200000 bytes', '2 MB'),
          {
            variant: 'error',
          }
        );
      } else {
        const acceptPdfFiles = acceptedFiles[0]?.type === 'application/pdf';
        const acceptedImagesFiles =
          (acceptedFiles[0]?.type === 'image/jpeg' ||
            acceptedFiles[0]?.type === 'image/png') &&
          (title === 'Passport Size Photo' ||
            title.toLowerCase().includes('photo') ||
            title.toLowerCase().includes('passport') ||
            title === 'Cheque');
        if (acceptPdfFiles) {
          onChange([...value, ...acceptedFiles]);
        } else if (acceptedImagesFiles) {
          onChange([...value, ...acceptedFiles]);
        } else {
          enqueueSnackbar('Only the mentioned file formats are accepted', {
            variant: 'error',
          });
        }
      }
    },
  });

  const fileUploadMobile = (e) => {
    const hasFiles = e.target.files;
    if (hasFiles[0].size > 2000000) {
      enqueueSnackbar('File is greater than 2MB', {
        variant: 'error',
      });
    } else {
      const acceptFiles =
        title.toLowerCase().includes('Cheque') ||
        title.toLowerCase().includes('photo') ||
        title.toLowerCase().includes('passport')
          ? ['image/jpeg', 'image/png']
          : ['application/pdf'];
      if (acceptFiles.includes(hasFiles[0].type)) {
        onChange([...value, ...hasFiles]);
      } else {
        enqueueSnackbar('Only the mentioned file formats are accepted', {
          variant: 'error',
        });
      }
    }
    handleClose();
  };

  const convertBase64ToFile = (fileName) => {
    setLoader(true);
    getDocumentByDocId(props?.recordId)
      .then((res) => {
        if (res?.success === true) {
          const fileType = props?.fileName?.split('.')[1];
          const fileBase64 = `data:${
            fileType === 'pdf' ? 'application' : 'image'
          }/${fileType};base64,${res?.data}`;
          let arr = fileBase64.split(',');
          let mime = arr[0].match(/:(.*?);/)[1];
          let bstr = atob(arr[1]);
          let n = bstr.length;
          let uint8Array = new Uint8Array(n);
          while (n--) {
            uint8Array[n] = bstr.charCodeAt(n);
          }
          let file = new File([uint8Array], fileName, { type: mime });
          setLoader(false);
          saveAs(file, fileName);
        }
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar('Something went wrong', { variant: 'error' });
        setLoader(false);
      });
  };

  const handlePreviewImage = () => {
    setLoader(true);
    getDocumentByDocId(props?.recordId)
      .then((res) => {
        if (res?.success === true) {
          setFilePreview(true);
          const fileType = props?.fileName?.split('.')[1];
          const previewData = `data:${
            fileType === 'pdf' ? 'application' : 'image'
          }/${fileType};base64,${res?.data}`;
          setPreviewImage(previewData);
          setFileType(fileType);
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        enqueueSnackbar('Something went wrong', { variant: 'error' });
        setLoader(false);
      });
  };

  return (
    <>
      {loader && <KenLoader />}
      <Grid
        container
        spacing={1}
        mt={1}
        mb={1}
        justifyContent="left"
        className={classes.container}
      >
        <Grid item md={3} xs={12}>
          <Typography variant="body5" className={classes.documentLabel}>
            {title}
          </Typography>
          {isMobileScreen ? (
            <Box display="flex" justifyContent="center" alignItems="flex-start">
              {getStatus({
                isMobileScreen,
                status,
                classes,
                getRootProps,
                getInputProps,
                open,
              })}
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={menuOpen ? 'long-menu' : undefined}
                aria-expanded={menuOpen ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                className={classes.moreOptions}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                  },
                }}
              >
                {fileName && (
                  <MenuItem
                    className={classes.menuItem}
                    onClick={() => {
                      handlePreviewImage();
                    }}
                  >
                    <img
                      src={Eye}
                      alt="view"
                      className={classes.mobileMenuIcon}
                    />
                    <label>View</label>
                  </MenuItem>
                )}
                {fileName && (
                  <MenuItem
                    className={classes.menuItem}
                    onClick={() => {
                      handleClose();
                      try {
                        if (!!fileName) {
                          convertBase64ToFile(fileName);
                        }
                      } catch (e) {}
                    }}
                  >
                    <img
                      src={Download}
                      alt="view"
                      className={classes.mobileMenuIcon}
                    />
                    <label>Download</label>
                  </MenuItem>
                )}
                {status !== 'Accepted' && (
                  <MenuItem
                    className={classes.menuItem}
                    onClick={() => {
                      handleClose();
                      open();
                    }}
                  >
                    <img
                      src={Replace}
                      alt="view"
                      className={classes.mobileMenuIcon}
                    />
                    <input
                      onChange={(e) => {
                        fileUploadMobile(e);
                      }}
                      multiple={false}
                      size={2000000}
                      accept={
                        title.toLowerCase().includes('photo')
                          ? 'image/jpeg, image/png'
                          : 'application/pdf'
                      }
                      id="mobileDrop"
                      type="file"
                      style={{ display: 'none' }}
                    />
                    <span>
                      <label htmlFor="mobileDrop">Replace Document</label>
                    </span>
                  </MenuItem>
                )}
              </Menu>
            </Box>
          ) : null}
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          textAlign={isMobileScreen ? 'left' : undefined}
        >
          {fileName?.length > 35 ? (
            <Tooltip
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
              title={fileName}
            >
              <Typography variant="body4">
                {`${fileName?.substring(0, 18)}..` || '---'}
              </Typography>
            </Tooltip>
          ) : (
            <Typography variant="body4">{fileName || '---'} </Typography>
          )}
        </Grid>
        {!isMobileScreen
          ? getStatus({
              isMobileScreen,
              status,
              classes,
              getRootProps,
              getInputProps,
              open,
            })
          : null}
        {!isMobileScreen && (
          <Grid item md={2} xs={12}>
            <Grid container justifyContent="center" spacing={3}>
              {(status === 'Pending Review' || status === 'Accepted') && (
                <Grid item>
                  <FileDownloadIcon
                    className={classes.icon}
                    onClick={() => {
                      try {
                        if (!!fileName) {
                          convertBase64ToFile(fileName);
                        }
                      } catch (e) {}
                    }}
                  />
                </Grid>
              )}
              {(status === 'Pending Review' || status === 'Accepted') && (
                <Grid item>
                  <VisibilityIcon
                    className={classes.icon}
                    onClick={() => {
                      handlePreviewImage();
                    }}
                  />
                </Grid>
              )}
              <Grid item {...getRootProps({ className: 'dropzone' })}>
                <input {...getInputProps()} />
                {status === 'Rejected' ? (
                  <Tooltip
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    title={'Please reupload the document'}
                  >
                    <UploadIcon
                      onClick={open}
                      className={classes.iconRejected}
                    />
                  </Tooltip>
                ) : (
                  <>
                    {/* {moment(expiryDate).diff(moment()) > 0 && ( */}
                    <Tooltip
                      TransitionComponent={Fade}
                      TransitionProps={{ timeout: 600 }}
                      title={'Upload'}
                    >
                      <UploadIcon
                        onClick={open}
                        className={classes.icon}
                        style={{
                          fontSize: 26,
                          color: status === 'Accepted' && 'lightgray',
                        }}
                      />
                    </Tooltip>
                    {/* )} */}
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        )}
        <KenDialog
          open={filePreview}
          handleClose={() => {
            setFilePreview(false);
          }}
        >
          {fileType === 'pdf' ? (
            <>
              {window.innerWidth < 450 ? (
                <div style={{ width: '100%', height: '400px' }}>
                  <FileViewer fileType={'pdf'} filePath={previewImage} />
                </div>
              ) : (
                <iframe
                  id="content_preview_pdf"
                  title={title}
                  src={previewImage}
                  style={{ width: '100%', height: '400px' }}
                />
              )}
            </>
          ) : (
            <img
              alt={title}
              src={previewImage}
              style={{ width: '100%', height: '400px', objectFit: 'contain' }}
            />
          )}
        </KenDialog>
      </Grid>
    </>
  );
}
